import Icon from './Icon';

const Save = ({ className }) => (
  <Icon name="save" className={className} viewBox="0 0 18 18">
    <polygon points="0,0 4,0 4,6 14,6 14,0 15,0 18,3 18,18 17,18 16,18 16,10 2,10 2,18 0,18 " />
    <rect x="9" width="3" height="5" />
    <rect x="3" y="11" width="12" height="7" />
  </Icon>
);

export default Save;
